import { default as actions } from "./actions";
import { default as SettingsReducer, sliceActions } from "./reducer";

export { default as SettingsSaga } from "./sagas";
export { default as SettingSelectors } from "./selectors";

const SettingActions = { ...actions, ...sliceActions };
export { SettingsReducer, SettingActions };
